import { IntegrationElementLevel } from '@integration-app/sdk'

import { ConnectionLevelImportFieldMappingUnitConfig } from './ConnectionLevelImportFieldMapping'
import { IntegrationLevelImportFieldMappingUnitConfig } from './IntegrationLevelImportFieldMappingUnitConfig'
import { UniversalImportFieldMappingUnitConfig } from './UniversalImportFieldMappingUnitConfig'
import { useGenericConfig } from '../contexts/generic-config-context'

export function ImportFieldMappingUnitConfig() {
  const { level } = useGenericConfig()

  switch (level) {
    case IntegrationElementLevel.UNIVERSAL:
      return <UniversalImportFieldMappingUnitConfig />
    case IntegrationElementLevel.CONNECTOR:
      return <IntegrationLevelImportFieldMappingUnitConfig />
    case IntegrationElementLevel.CONNECTION:
      return <ConnectionLevelImportFieldMappingUnitConfig />
    default:
      return null
  }
}
